import { Expose, Type } from "class-transformer";

import { User } from "@shared/models/user.model";

import { DocumentAIChatSessionModel } from "./chat.model";

/**
 * Lightweight model for displaying a document in a list.
 * Contains only metadata, no content.
 */
export class DocumentListItemModel {
  @Expose()
  id!: string;

  @Expose()
  title!: string;

  @Expose()
  latestVersion!: number;

  @Expose()
  position!: number;

  @Expose()
  createdAt!: Date;

  @Expose()
  updatedAt!: Date;

  @Expose()
  creatorId!: string;

  @Expose()
  currentAiModelId?: string | null;

  isNew?: boolean;
  // Optional extras for shared docs
  @Expose()
  permission?: "VIEW" | "EDIT";
  @Expose()
  hasAnyShare?: boolean;
  @Expose()
  isPublic?: boolean;
  @Expose()
  isSharedWithMe?: boolean;

  @Expose()
  folderId!: string;

  type: "document" = "document";

  constructor(data: Partial<DocumentListItemModel>) {
    Object.assign(this, data);
  }
}

/**
 * Full document model, including content for a specific version.
 * Used when viewing/editing a single document.
 */
export class DocumentModel extends DocumentListItemModel {
  @Expose()
  version!: number; // The specific version number of the content being viewed

  @Expose()
  content!: string;

  @Expose()
  @Type(() => User)
  creator?: User;

  @Expose()
  chatSessions?: DocumentAIChatSessionModel[];

  constructor(data: Partial<DocumentModel>) {
    super(data);
    Object.assign(this, data);
  }
}

/**
 * Lightweight model for a document's version history.
 */
export class DocumentVersionListItemModel {
  @Expose()
  id!: string;

  @Expose()
  version!: number;

  @Expose()
  createdAt!: Date;

  @Expose()
  creatorId!: string;

  @Expose()
  @Type(() => User)
  creator?: User | null;

  constructor(data: Partial<DocumentVersionListItemModel>) {
    Object.assign(this, data);
  }
}

/**
 * Full document version model, including content.
 */
export class DocumentVersionModel extends DocumentVersionListItemModel {
  @Expose()
  content!: string;

  constructor(data: Partial<DocumentVersionModel>) {
    super(data);
    Object.assign(this, data);
  }
}
